/* Noorns redesign: footer behavior (mockup build_pages.py MENU_JS_CODE, footer parts).
   - Shop, Learn and Company are <details>: always open from 761 px up, tap to open on phones.
   - Cookie preferences reopens Shopify's consent banner. The button stays hidden unless Shopify's banner
     API is on the page, so it never shows as a dead button.
   - After a sign-up the confirmation line takes focus, so a screen reader hears it. */
(function () {
  var cols = document.querySelectorAll('#noorns-footer .nf-col');
  var wide = window.matchMedia('(min-width:761px)');
  function sync() { cols.forEach(function (c) { c.open = wide.matches; }); }
  cols.forEach(function (c) { c.addEventListener('toggle', function () { if (wide.matches && !c.open) c.open = true; }); });
  sync();
  if (wide.addEventListener) wide.addEventListener('change', sync);

  var cookie = document.getElementById('footer-cookie-preferences');
  function prefsReady() { return window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function'; }
  if (cookie) {
    var tries = 0;
    (function wait() {
      if (prefsReady()) { cookie.hidden = false; return; }
      if (++tries < 40) setTimeout(wait, 250);
    })();
    cookie.addEventListener('click', function () { if (prefsReady()) window.privacyBanner.showPreferences(); });
  }

  var done = document.getElementById('footer-signup-done');
  if (done) { done.scrollIntoView({ block: 'center' }); done.focus({ preventScroll: true }); }
})();
